import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "./AlertModal.module.css";

const AlertModal = ({ isOpen, type, title, message, defaultValue, onClose }) => {
  const { t } = useTranslation("common");
  const [inputValue, setInputValue] = useState(defaultValue);
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue, isOpen]);

  useEffect(() => {
    if (isOpen && type === "prompt" && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen, type]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (type === "prompt") {
      onClose(inputValue);
    } else if (type === "confirm") {
      onClose(true);
    } else {
      onClose();
    }
  };

  const handleCancel = () => {
    if (type === "prompt") {
      onClose(null);
    } else if (type === "confirm") {
      onClose(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && type !== "prompt") {
      handleConfirm();
    } else if (e.key === "Escape") {
      if (type === "alert") {
        handleConfirm();
      } else {
        handleCancel();
      }
    }
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.background}
        onClick={type === "alert" ? handleConfirm : handleCancel}
        aria-hidden="true"
      />

      <div className={styles.box} onKeyDown={handleKeyPress}>
        <h2 className={styles.header}>{title}</h2>

        <div className={styles.content}>
          <p className={styles.message}>{message}</p>

          {type === "prompt" && (
            <input
              ref={inputRef}
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className={styles.input}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleConfirm();
                }
              }}
            />
          )}
        </div>

        <div className={styles.actions}>
          {type === "alert" ? (
            <button onClick={handleConfirm} className={styles.confirmButton} autoFocus>
              {t("ok") || "OK"}
            </button>
          ) : (
            <>
              <button onClick={handleCancel} className={styles.cancelButton}>
                {t("cancel") || "Avbryt"}
              </button>
              <button onClick={handleConfirm} className={styles.confirmButton} autoFocus>
                {t("ok") || "OK"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
